import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { selectDefaultFolder, selectFolder, isValidMailFolderId } from 'mini-mail-folder-actions';

/**
 * Selects a folder view with fallback mechanism based on the input folderId value
 */
export default function selectFolderWithFallback(routerFolderId: string): Promise<void> {
    // if no id is specified in the URL, select default folder
    // 'msgfolderroot' is only used in search, does not contain any mail, so go for default folder
    /**
     * TODO: Search->select other than inbox conversation->refresh page, this will show inbox in URL
     * As the default is inbox and here we dont know from which folder this conversation came from.
     * May be check here for parent folder and then select that as folder
     * As of now there is no impact on any user flow due to this.
     *  */
    if (!routerFolderId || folderIdToName(routerFolderId) === 'msgfolderroot') {
        selectDefaultFolder();
        return Promise.resolve();
    }

    // routerFolderId could be distinguished folderId like 'inbox', 'sentitems' which is called through router
    const folderId = folderNameToId(routerFolderId) || routerFolderId;

    // Invalid Id specified in the URL, fallback to default folder
    if (!isValidMailFolderId(folderId)) {
        selectDefaultFolder();
        return Promise.resolve();
    }

    return selectFolder(folderId);
}
